function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { EnvType } from '@wix/editor-platform-private-api';
import { ApplicationType } from '@wix/editor-application';
import { createEditorPlatformWorkerError, EditorPlatformWorkerErrorCode } from '../../errors';
import { IFrameHostEndpoint } from '@wix/editor-platform-transport';
import { PlatformConsumerEnvironmentAPIType } from '@wix/editor-platform-environment-api';
var _connectedIframes = /*#__PURE__*/new WeakMap();
var _pendingIframes = /*#__PURE__*/new WeakMap();
var _PlatformFrameStrategy_brand = /*#__PURE__*/new WeakSet();
export class PlatformFrameStrategy {
  constructor(ps, limitedPrivateAPI, events) {
    this.ps = ps;
    this.limitedPrivateAPI = limitedPrivateAPI;
    this.events = events;
    /**
     * Cleanup closed iframes.
     * Closed iframes do not have content windows on them
     */
    _classPrivateMethodInitSpec(this, _PlatformFrameStrategy_brand);
    _classPrivateFieldInitSpec(this, _connectedIframes, new Map());
    _classPrivateFieldInitSpec(this, _pendingIframes, new Set());
  }
  notify(event) {
    _assertClassBrand(_PlatformFrameStrategy_brand, this, _cleanup).call(this);
    Array.from(_classPrivateFieldGet(_connectedIframes, this).values()).forEach(frameAPI => {
      void frameAPI.notify(event);
    });
  }
  connect(appDefinitionId, iframe) {
    /**
     * the guard to resolve cases when for some reason
     * React ref is called multiple times which leads
     * to connect the same iframe to EP infra multiple times
     */
    if (_classPrivateFieldGet(_pendingIframes, this).has(iframe)) {
      return;
    }
    _classPrivateFieldGet(_pendingIframes, this).add(iframe);
    const frameInitEvent = this.events.factories.createIframeInitEvent(iframe.src, iframe.id || iframe.src);
    return this.events.withEvent(frameInitEvent, async () => {
      if (!iframe.contentWindow) {
        throw createEditorPlatformWorkerError(EditorPlatformWorkerErrorCode.FrameInitError, 'frame "contentWindow" is not available');
      }
      let applicationPrivateAPI;

      /**
       * to discuss –
       * currently we have cases when we run frame for CE,
       * but there is no running application with the needed appDefinitionId
       * by design we throw exception if call any operation over application
       * which does not exist.
       *
       * this is temporary try/catch
       *
       * as soon as we run CE app, we remove this statement.
       */
      try {
        applicationPrivateAPI = await this.ps.apps.getPrivateAPI(appDefinitionId);
      } catch (e) {
        applicationPrivateAPI = {};
      }
      IFrameHostEndpoint.connect(iframe, async transport => {
        const frameAPI = await transport.waitAPI(PlatformConsumerEnvironmentAPIType.Frame);
        _classPrivateFieldGet(_connectedIframes, this).set(iframe, frameAPI);
        const limitedPrivateAPI = this.limitedPrivateAPI.build({
          type: ApplicationType.EditorAddon,
          env: EnvType.Frame
        });
        const manifestsManager = this.ps.manifestsManager;
        const manifestContextId = manifestsManager.buildManifestContext(() => {});
        await frameAPI.initEnvironment({
          appDefinitionId,
          context: {
            manifestContextId,
            appDefinitionId
          },
          privateAPI: limitedPrivateAPI,
          applicationPrivateAPI
        });
      });
    });
  }
}
function _cleanup() {
  Array.from(_classPrivateFieldGet(_connectedIframes, this).keys()).forEach(iframe => {
    if (!iframe.contentWindow) {
      _classPrivateFieldGet(_connectedIframes, this).delete(iframe);
    }
  });
  Array.from(_classPrivateFieldGet(_pendingIframes, this).values()).forEach(iframe => {
    if (!iframe.contentWindow) {
      _classPrivateFieldGet(_pendingIframes, this).delete(iframe);
    }
  });
}
//# sourceMappingURL=PlatformFrameStrategy.js.map